import { TStatesRetriever } from '../types';
import buildStateObject from './buildStateObject';
import getColorState from './getColorState';

/**
 * Con este método es posible construir un objeto con las propiedades
 * necesarias para aplicar los colores correspondientes a los estados deseados
 * a partir de la definición provista.
 */
const getColorStates: TStatesRetriever = (definition, palette, states) => {
  return {
    ...(states?.default !== false ? definition : null),
    ...(states?.checked !== false
      ? buildStateObject(
          getColorState(definition, 'checked', palette),
          'checked',
        )
      : null),
    ...buildStateObject(getColorState(definition, 'focus', palette), 'focus'),
    ...(states?.selected !== false
      ? buildStateObject(
          getColorState(definition, 'selected', palette),
          'selected',
        )
      : null),
    ...(states?.hover !== false
      ? buildStateObject(getColorState(definition, 'hover', palette), 'hover')
      : null),
    ...(states?.active !== false
      ? buildStateObject(getColorState(definition, 'active', palette), 'active')
      : null),
    ...(states?.disabled !== false
      ? buildStateObject(
          getColorState(definition, 'disabled', palette),
          'disabled',
        )
      : null),
    ...(states?.readonly !== false
      ? buildStateObject(
          getColorState(definition, 'readonly', palette),
          'readonly',
        )
      : null),
  };
};

export default getColorStates;
